export const MAX_SERIAL_NUMBER_LENGTH = 21;

// Determine initial suffix - use existing suffix or first valid suffix if available
export const getInitialSuffix = (selectedAssetDetails) => {
    if (selectedAssetDetails?.suffix) {
        return {
            id: selectedAssetDetails.suffix,
            name: selectedAssetDetails.suffix
        };
    }

    // If no suffix but serial number contains underscore, check if it's a valid suffix
    if (selectedAssetDetails?.serialNumber?.includes('_') && selectedAssetDetails?.validSuffixes?.length > 0) {
        const parts = selectedAssetDetails.serialNumber.split('_');
        const suggestedSuffix = parts[parts.length - 1];
        const validSuffix = selectedAssetDetails.validSuffixes.find(s => s === suggestedSuffix);

        if (validSuffix) {
            return {
                id: validSuffix,
                name: validSuffix
            };
        }
    }

    // Default to first valid suffix if available
    if (selectedAssetDetails?.validSuffixes?.length > 0) {
        return {
            id: selectedAssetDetails.validSuffixes[0],
            name: selectedAssetDetails.validSuffixes[0]
        };
    }

    return null;
};
